module.exports = __webpack_public_path__ + "static/media/IMG_20180613_171114.d8369c12.jpg";